"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.requestData = void 0;

var _fetchNormalizeData = require("fetch-normalize-data");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var requestData = function requestData(config) {
  return function (dispatch, getState, defaultConfig) {
    var state = getState();
    var reducer = [state.data, dispatch];

    var fetchConfig = _objectSpread(_objectSpread({}, defaultConfig), config);

    var _ref = config || {},
        requestOnlyOnce = _ref.requestOnlyOnce;

    if (requestOnlyOnce) {
      var _ref2 = (0, _fetchNormalizeData.selectRequestByConfig)(state, config) || {},
          isSuccess = _ref2.isSuccess;

      if (isSuccess) return;
    }

    dispatch((0, _fetchNormalizeData.requestData)(config));
    return (0, _fetchNormalizeData.fetchToSuccessOrFailData)(reducer, fetchConfig);
  };
};

exports.requestData = requestData;
var _default = requestData;
exports["default"] = _default;